import { HttpClient, HttpDownloadProgressEvent, HttpEvent, HttpEventType, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SafeJSONParse } from '@app/core/helpers';
import { AiTemplates } from '@app/shared/AiTemplates';
import { ToastService } from '@app/shared/services/toast/toast.service';
import { Subject, Observable, BehaviorSubject, firstValueFrom, filter, map, scan } from 'rxjs';

export interface AiBus {
  context: string;
  payload: any;
  conversation?: AiConversation;
}

export interface AiConversation {
  Id: string;
  payload: any;
}

export interface AiContextBus {
  context: string;
  payload: any;
}

export interface PreRequisiteBus {
  context: string;
  payload: any;
}

export enum ReflecxModules {
  GlobalDashboard,
  SurveyDesigner,
}

@Injectable({ providedIn: 'root' })
export class AiChatService {
  public module: ReflecxModules = ReflecxModules.GlobalDashboard;
  public chatBoxMaximize = false;
  public showAiMode = false;
  public showHumaninLoop = false;
  public loading = false;
  public loadingJSON = false;
  public loadingIntent = false;
  conversation: any;
  public get isLoading() {
    return this.loading || this.loadingJSON || this.loadingIntent;
  }
  accumulatedText = '';
  LLM_URL = 'http://localhost:8000/api/chat';
  private bus = new Subject<AiBus>();
  public prerequisite$ = new Subject<PreRequisiteBus>();
  public contextbus$ = new BehaviorSubject<AiContextBus>({ payload: [], context: 'EMPTY' });
  private messageSource = new Subject<string>();
  public completedSource = new Subject<string>();
  public humanInLoopHistory: Array<{
    message: string;
    from: string;
    type: string;
    data: Array<any>;
    conversation?: AiConversation;
  }> = [];
  public messages: Array<{ message: string; from: string; type: string; data: Array<any> }> = [
    {
      type: 'chat',
      data: [],
      from: 'chatbot',
      message:
        'Welcome. I hope this message finds you well and are able to participate in the chat. How can I assist you today? 😊',
    },
  ];

  bus$: Observable<AiBus> = this.bus.asObservable();
  messageStream$: Observable<string> = this.messageSource.asObservable();

  constructor(private toast: ToastService, private http: HttpClient) {}

  async askForJsonOnly(message: string, template: string) {
    message = `${message}`;
    if (this.loadingJSON) {
      return false;
    }

    let accumulatedText = '';
    this.loadingJSON = true;
    const response = await fetch(this.LLM_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message: template }),
    });

    const reader = response.body?.getReader();
    const decoder = new TextDecoder();

    if (reader) {
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value);
        accumulatedText += chunk;
      }

      const json = SafeJSONParse(accumulatedText);
      this.loadingJSON = false;
      return json;
    }
    this.loadingJSON = false;
    return [];
  }

  async askForConversationV2(message: string, template: string) {
    try {
      message = `${message}`;
      if (this.loading) {
        return false;
      }
      this.messages.push({
        data: [],
        type: 'chat',
        from: 'user',
        message: message,
      });

      this.accumulatedText = '';
      this.loading = true;

      if (!this.conversation) {
        const conversation: any = await this.http
          .disableLoader()
          .post('/ai/conversations', {
            title: 'Total Alert Widget Info',
            provider: 'Gemini',
            model: 'gemini-3.5-flash',
          })
          .toPromise();
        this.conversation = conversation;
      }

      this.streamChat({
        conversationId: this.conversation.Id,
        content: template,
        provider: 'Gemini',
        model: 'gemini-3.5-flash',
      }).subscribe({
        next: (chunk: string) => {
          this.accumulatedText += chunk;
          this.messageSource.next(this.accumulatedText);
          this.loading = false;
        },
        error: (err) => {
          console.error('Error streaming:', err);
        },
        complete: () => {
          this.messages.push({
            data: [],
            type: 'chat',
            from: 'chatbot',
            message: this.accumulatedText,
          });
          this.messageSource.next('');
          this.accumulatedText = '';
          this.completedSource.next('completed');
        },
      });

      // const response: any = await this.http.disableLoader().post('/ai/chat/send', {
      //   "conversationId": conversation.Id,
      //   "content": template,
      //   "provider": "Gemini",
      //   "model": "gemini-3.5-flash"
      // }).toPromise()

      // this.loading = false;

      // this.messages.push({
      //   data: [],
      //   type: 'chat',
      //   from: 'chatbot',
      //   message: response.Content
      // })

      // this.messageSource.next('');
      // this.accumulatedText = '';

      // setTimeout(() => {
      //   this.completedSource.next('completed')
      // }, 1000)

      // const reader = response.body?.getReader();
      // const decoder = new TextDecoder();
      // let isFirstChunk = true;

      // if (reader) {
      //   while (true) {
      //     const { done, value } = await reader.read();
      //     if (done) break;

      //     if (isFirstChunk) {
      //       isFirstChunk = false;
      //       this.loading = false;
      //     }

      //     const chunk = decoder.decode(value);
      //     this.accumulatedText += chunk;

      //     // Push the latest full string to all subscribers
      //     this.messageSource.next(this.accumulatedText);
      //     this.completedSource.next('completed')
      //   }

      //   this.messages.push({
      //     data: [],
      //     type: 'chat',
      //     from: 'chatbot',
      //     message: this.accumulatedText
      //   })

      //   this.messageSource.next('');
      //   this.accumulatedText = '';

      //   setTimeout(() => {
      //     this.completedSource.next('completed')
      //   }, 1000)
      // }
    } catch (error) {
      this.loading = false;
    }
  }

  async askForConversation(message: string, template: string) {
    message = `${message}`;
    if (this.loading) {
      return false;
    }
    this.messages.push({
      data: [],
      type: 'chat',
      from: 'user',
      message: message,
    });

    this.accumulatedText = '';
    this.loading = true;
    const response = await fetch(this.LLM_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message: template }),
    });

    const reader = response.body?.getReader();
    const decoder = new TextDecoder();
    let isFirstChunk = true;

    if (reader) {
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        if (isFirstChunk) {
          isFirstChunk = false;
          this.loading = false;
        }

        const chunk = decoder.decode(value);
        this.accumulatedText += chunk;

        // Push the latest full string to all subscribers
        this.messageSource.next(this.accumulatedText);
        this.completedSource.next('completed');
      }

      this.messages.push({
        data: [],
        type: 'chat',
        from: 'chatbot',
        message: this.accumulatedText,
      });

      this.messageSource.next('');
      this.accumulatedText = '';

      setTimeout(() => {
        this.completedSource.next('completed');
      }, 1000);
    }
  }

  async getAiResponse(template: string) {
    let accumulatedText = '';
    this.loadingIntent = true;

    const response = await fetch(this.LLM_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message: template }),
    });

    const reader = response.body?.getReader();
    const decoder = new TextDecoder();
    let isFirstChunk = true;

    if (reader) {
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        if (isFirstChunk) {
          isFirstChunk = false;
        }

        const chunk = decoder.decode(value);
        accumulatedText += chunk;
      }
      this.loadingIntent = false;
      return SafeJSONParse(accumulatedText);
    }
    this.loadingIntent = false;
    return { intent: 'UNKNOWN', confident: 0.0 };
  }

  async getAiResponseV2(template: string, conversation?: AiConversation, defaultValue?: any, jsonParse = true) {
    try {
      this.loading = true;

      if (!conversation) {
        conversation = await this.http
          .disableLoader()
          .post<AiConversation>('/ai/conversations', {
            title: '',
            provider: 'Ollama',
            model: 'llama3.1:8b',
          })
          .toPromise();
      }

      const response: any = await this.http
        .disableLoader()
        .post('/ai/chat/send', {
          conversationId: conversation?.Id,
          content: template,
          provider: 'Ollama',
          model: 'llama3.1:8b',
        })
        .toPromise();

      this.loading = false;

      return { conversation, response: jsonParse ? SafeJSONParse(response.Content) : response.Content };
    } catch (error) {
      this.loading = false;
      return { conversation, response: defaultValue };
    }
  }

  sendToAll(context: string, data: any, conversation?: AiConversation) {
    this.bus.next({ context: context, payload: data, conversation });
  }

  async askDeepSeek(message: string) {
    if (this.module === ReflecxModules.SurveyDesigner) {
      this.prerequisite$.next({ payload: null, context: 'Questions' });
      const questions = await firstValueFrom(this.contextbus$);
      const actionClassifier = await this.getAiResponse(
        `${AiTemplates.InentClassifier(message, JSON.stringify(questions.payload))}`
      );
      switch (actionClassifier.intent) {
        case 'ADD':
          const newQuestions = await this.askForJsonOnly(
            message,
            `${AiTemplates.QuestionOnlyForJson(JSON.stringify([]), message)}`
          );
          this.humanInLoopHistory.push({
            type: 'Add Question',
            from: 'chatbot',
            message: 'These question will be added in survey designer please confirm to add it',
            data: newQuestions,
          });
          this.showHumaninLoop = true;
          break;
        case 'UPDATE':
          const updatedQuestions = await this.askForJsonOnly(
            message,
            `${AiTemplates.UpdateQuestionJson(message, JSON.stringify(questions.payload), actionClassifier.target_id)}`
          );
          this.bus.next({ context: 'UPDATE_QUESTIONS', payload: updatedQuestions });
          break;
        default:
          this.toast.error('No Intent Provided');
      }
    } else if (this.module === ReflecxModules.GlobalDashboard) {
      this.askForConversation(message, `${AiTemplates.QuestionOnlyForConversation(message)}`);
    }
  }

  async ask(message: string) {
    this.loading = true;
    if (this.module === ReflecxModules.SurveyDesigner) {
      this.prerequisite$.next({ payload: null, context: 'Questions' });
      const questions = await firstValueFrom(this.contextbus$);
      const { conversation, response: actionClassifier } = await this.getAiResponseV2(
        `${AiTemplates.InentClassifier(message, JSON.stringify(questions.payload))}`,
        undefined,
        { intent: 'UNKNOWN', confident: 0.0 }
      );
      switch (actionClassifier.intent) {
        case 'ADD':
          const questionResponse = await this.getAiResponseV2(
            `${AiTemplates.QuestionOnlyForJson(JSON.stringify([]), message)}`,
            conversation
          );
          this.humanInLoopHistory.push({
            type: 'Add Question',
            from: 'chatbot',
            message: 'These question will be added in survey designer please confirm to add it',
            data: questionResponse.response,
            conversation: questionResponse.conversation,
          });
          this.showHumaninLoop = true;
          break;
        case 'UPDATE':
          const updatedQuestions = await this.getAiResponseV2(
            `${AiTemplates.UpdateQuestionJson(message, JSON.stringify(questions.payload), actionClassifier.target_id)}`,
            conversation
          );
          this.bus.next({
            context: 'UPDATE_QUESTIONS',
            conversation: updatedQuestions.conversation,
            payload: updatedQuestions.response,
          });
          break;
        default:
          this.toast.error('No Intent Provided');
      }
    } else if (this.module === ReflecxModules.GlobalDashboard) {
      this.getAiResponseV2(`${AiTemplates.QuestionOnlyForConversation(message)}`);
    }
    this.loading = false;
  }

  streamChat(payload: any): Observable<string> {
    const request = new HttpRequest('POST', '/ai/chat/stream', payload, {
      reportProgress: true,
      responseType: 'text', // Required to get event.partialText
    });
    return this.http
      .disableLoader()
      .request(request)
      .pipe(
        // 1. Only listen to Download Progress events
        filter((event: any) => event.type === HttpEventType.DownloadProgress),
        // 2. Extract cumulative text received so far
        map((event: HttpDownloadProgressEvent) => event.partialText || ''),
        // 3. Compute only the new text characters (delta) received since the last event
        scan(
          (acc, currentText) => {
            const delta = currentText.substring(acc.lastLength);
            return {
              lastLength: currentText.length,
              delta: delta,
            };
          },
          { lastLength: 0, delta: '' }
        ),
        map((state) => state.delta),
        // 4. Group text delta into lines and save incomplete buffer lines
        scan(
          (acc, delta) => {
            const total = acc.buffer + delta;
            const lines = total.split('\n');
            const buffer = lines.pop() || ''; // Remaining buffer line
            return {
              buffer: buffer,
              newLines: lines,
            };
          },
          { buffer: '', newLines: [] as string[] }
        ),
        // 5. Parse complete lines (data: {...}) and yield content
        map((state) => {
          let textResult = '';
          for (const line of state.newLines) {
            const cleanLine = line.trim();
            if (cleanLine.startsWith('data:')) {
              try {
                const jsonStr = cleanLine.substring(5).trim();
                const parsed = JSON.parse(jsonStr);
                if (parsed.content) {
                  textResult += parsed.content;
                }
              } catch (err) {
                // Ignore json parsing on metadata or empty lines
              }
            }
          }
          return textResult;
        }),
        // 6. Avoid emitting empty changes
        filter((text) => text.length > 0)
      );
  }
}
